export class ResultHeadingModel {
    result_proc: number;
    result_sequence: number;
    result_name: string;
    result_clinic: number;
    result_name_group: string[]|null = null;
    
    constructor(   
        result_proc: number,
        result_sequence: number,
        result_name: string,
        result_clinic: number,
        result_name_group: string[]|null = null
    ) { 
        this.result_proc = result_proc
        this.result_sequence = result_sequence
        this.result_name = result_name
        this.result_clinic = result_clinic
        this.result_name_group = result_name_group
    }

}


